import { render, staticRenderFns } from "./SupplierTable.vue?vue&type=template&id=1b375384&"
import script from "./SupplierTable.vue?vue&type=script&lang=ts&"
export * from "./SupplierTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports